import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "@/App";
import { safeHtml } from "@/lib/sanitize";
import Seo from "@/components/Seo";

function StaticPage({ slug, accent = "sky" }) {
  const [page, setPage] = useState(null);
  useEffect(() => {
    axios.get(`${API}/pages/${slug}`).then((r) => setPage(r.data));
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) return <div className="max-w-xl mx-auto px-6 py-20 text-[var(--text-muted)]">Cargando…</div>;

  const descMap = {
    aniversario: "X Aniversario de la Tertulia In Dubio (2014–2024): celebración del décimo aniversario, estadísticas del archivo, homenaje a miembros fundadores y reflexiones sobre una década de pensamiento compartido en Sevilla.",
    nacimiento: "Cómo y por qué nació la Tertulia In Dubio en Sevilla el 1 de diciembre de 2014. Texto fundacional de Ernesto Holgado Ramos, miembro fundador.",
    historia: "Historia de la Tertulia Social de Sevilla (Tertulia In Dubio): sus principios, su trayectoria y los debates que han marcado más de una década de diálogo ciudadano.",
  };

  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-10 py-12 md:py-20" data-testid={`page-${slug}`}>
      <Seo
        title={page.title}
        description={descMap[slug] || `${page.title} · Tertulia In Dubio, Tertulia Social de Sevilla.`}
        path={`/${slug}`}
      />
      <span className="eyebrow"><span className="decor-line"></span>Tertulia In Dubio</span>
      <h1 className="font-serif text-6xl md:text-7xl mt-4 leading-[0.95]">{page.title}</h1>
      <div className="hairline my-10"></div>
      <div className="prose-bio text-[16px] max-w-[720px]" dangerouslySetInnerHTML={safeHtml(page.content_html)} />
      <div className="mt-16">
        <Link to="/invitados" className="btn-ghost">Ir al archivo de invitados →</Link>
      </div>
    </div>
  );
}

export default StaticPage;
